module.exports = __webpack_public_path__ + "images/menu-work.svg?4265efecdb68814024d467f983897fe5";